/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { v4 as uuidv4 } from 'uuid';
import { Environment } from '../../../../environment';
import axios, { AxiosError } from 'axios';
import { Api } from '../../axiosApi';
import { comOffline, somenteOnline } from '../../../../offline/servico';
import { buscarProdutoDetalhe, buscarProdutos, verificarEstoqueLocal } from '../../../../offline/cadastros';

export interface IListagemDeReferencias {
  idref: string;
  referencia: string;
  original: boolean;
}

export interface IListagemDeProdutos {
  idproduto: string;
  idgrupo: string;
  idsubgrupo: string;
  idref: string;
  codinterno: string;
  localizado: string;
  local: string;
  foto: string;
  original: boolean;
  marca: string;
  descricao: string;
  un: string;
  ean: string;
  referencia: string;
  infadd: string;
  origem: number;
  cfop: number;
  icms: number;
  cst: string;
  cstconfins: string;
  cstpis: string;
  cstipi: string;
  quan: number;
  ppis: number;
  pipi: number;
  pconfins: number;
  ncm: string;
  cest: string;
  anp: string;
  pnacional: number;
  pimportado: number;
  vpartida: number;
  preco: number;
  pvenda: number;
  ppromocao: number;
  picms: number;
  pfrete: number;
  pseguro: number;
  desconto: number;
  comissao: number;
  margem: number;
  estoqueminino: number;
  status: boolean;
}
export interface IDetalhesProdutobyid {
  idgrupo: string;
  idsubgrupo: string | null;
  descricao: string;
  marca: string;
  localizado: string;
  foto: string;
  un: string;
  precocusto: number;
  ean: string;
  infadd: string;
  origem: number;
  cfop: string;
  icms: number;
  cst: string;
  cstcofins: string;
  cstpis: string;
  cstipi: string;
  pcofins: number;
  ppis: number;
  pipi: number;
  ncm: string;
  cest: string;
  descanp: string;
  cprodanp: string;
  pnacional: number;
  pimportado: number;
  // Percentual de GLP derivado de petróleo (só produto ANP cProdANP=
  // 210203001, ver pGLP no XML da NFe/NFCe).
  pglp: number;
  // Quantidade de GLP derivado de petróleo, em kg (só produto ANP cProdANP=
  // 210203001, ver qGLP no XML da NFe/NFCe).
  qtdglp: number;
  vpartida: number;
  preco: number;
  pvenda: number;
  ppromocao: number;
  picms: number;
  pfrete: number;
  pseguro: number;
  desconto: number;
  comissao: number;
  margem: number;
  estoqueminino: number;
  status: boolean;
}
export interface IGetProdutobyid {
  idgrupo: string;
  idsubgrupo: string | null;
  descricao: string;
  marca: string;
  localizado: string;
  foto: string;
  un: string;
  precocusto: number;
  ean: string;
  infadd: string;
  origem: number;
  cfop: string;
  icms: number;
  cst: string;
  cstcofins: string;
  cstpis: string;
  cstipi: string;
  pcofins: number;
  ppis: number;
  pipi: number;
  ncm: string;
  cest: string;
  descanp: string;
  cprodanp: string;
  pnacional: number;
  pimportado: number;
  // Percentual de GLP derivado de petróleo (só produto ANP cProdANP=
  // 210203001, ver pGLP no XML da NFe/NFCe).
  pglp: number;
  // Quantidade de GLP derivado de petróleo, em kg (só produto ANP cProdANP=
  // 210203001, ver qGLP no XML da NFe/NFCe).
  qtdglp: number;
  vpartida: number;
  preco: number;
  pvenda: number;
  ppromocao: number;
  picms: number;
  pfrete: number;
  pseguro: number;
  desconto: number;
  comissao: number;
  margem: number;
  estoqueminino: number;
  quan: number;
  status: boolean;
}
export interface IDetalhesReferencia {
  referencia: string;
}
export interface IDetalhesProduto {
  idgrupo: string | null;
  idsubgrupo: string | null;
  descricao: string;
  localizado: string;
  marca: string;
  precocusto: number;
  foto: string;
  un: string;
  ean: string;
  eanentrada: string;
  infadd: string;
  origem: number;
  cfop: string;
  icms: number;
  cst: string;
  cstcofins: string;
  cstpis: string;
  cstipi: string;
  pcofins: number;
  pipi: number;
  ppis: number;
  ncm: string;
  cest: string;
  descanp: string;
  cprodanp: string;
  pnacional: number;
  pimportado: number;
  // Percentual de GLP derivado de petróleo (só produto ANP cProdANP=
  // 210203001, ver pGLP no XML da NFe/NFCe).
  pglp: number;
  // Quantidade de GLP derivado de petróleo, em kg (só produto ANP cProdANP=
  // 210203001, ver qGLP no XML da NFe/NFCe).
  qtdglp: number;
  vpartida: number;
  preco: number;
  pvenda: number;
  ppromocao: number;
  picms: number;
  pfrete: number;
  pseguro: number;
  desconto: number;
  comissao: number;
  margem: number;
  estoqueminino: number;
  tax: boolean;
}
interface IListagemDeProdutosGetAlllist {
  idproduto: string;
  idgrupo: string;
  idsubgrupo: string;
  idref: string;
  descricao: string;
  referencia: string;
  codbarraentrada: string;
  codbarrasaida: string;
  precocompra: number;
  precocusto: number;
  pvenda: number;
  precosaida: number;
  status: boolean;
  un: string;
  percentual: number;
  frete: number;
  local: string;
  diasvencimento: number;
  marca: string;
  vencimento: boolean;
  obs: string;
  codinterno?: number;
  cfop: number;
  quan: number;
  // String mesmo ('00', '10', ...) — mesma coluna texto usada no cadastro
  // do produto (ver DetalheDeProduto.tsx), nunca foi numérica.
  cst: string;
  cstipi: string;
  cstpis: string;
  cstcofins: string;
  picms: number;
  pipi: number;
  ppis: number;
  pcofins: number;
  ean: string;
  ncm: string;
  origem: number;
  qtdglp?: number;
  tax?: boolean;
}
export interface IUpdateImg {
  urlimge: string;
}

type TComTotalCount = {
  data: IListagemDeProdutos[];
  totalCount: number;
}

type TComTotalCountreferencia = {
  data: IListagemDeReferencias[];
  totalCount: number;
}

type TComTotalCountGetAlllist = {
  data: IListagemDeProdutosGetAlllist[];
  totalCount: number;
}
interface ErrorResponse {
  errors: {
    default: string;
  };
}
export interface IListagemEntradasProd {
  titulo: string;
  valor: number;
}
export interface IListagemSaidaProd {
  titulo: string;
  valor: number;
}
export interface ITotais {
  devolucao: number;
  qtde: number;
  qtds: number;
  saldo: number;
}

type TComTotalCountDashboard = {
  totais: ITotais;
  venda: IListagemSaidaProd[];
  entrada: IListagemEntradasProd[];
  totalCount: number;
}

interface ErrorResponseCREATE {
  errors: {
    default: string;
  };
}
const getAllPage = async (page = 1, filter = '', tipo = '', limit = Environment.LIMITE_DE_LINHASSMALL): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = `/produtoslist?page=${page}&limit=${limit}&filter=${filter}&tipo=${tipo}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 0),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const getAllOnline = async (page = 1, filter = '', tipo = '', limit = Environment.LIMITE_DE_LINHASSMALL, modobusca = 'contem'): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = `/produtos?page=${page}&limit=${limit}&filter=${filter}&tipo=${tipo}&modobusca=${modobusca}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 0),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAllDashboard = async (idprod = ''): Promise<TComTotalCountDashboard | Error> => {
  try {
    const urlRelativa = `/produtosdashboard?idprod=${idprod}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        totais: data.totais,
        venda: data.venda,
        entrada: data.entrada,
        totalCount: Number(headers['x-total-count'] || 0),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAllVenda = async (page = 1, idprod = ''): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = `/listagemsaida?page=${page}&limit=${Environment.LIMITE_DE_LINHASSMALL}&idprod=${idprod}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 0),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAllEntrada = async (page = 1, idprod = ''): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = `/listagementrada?page=${page}&limit=${Environment.LIMITE_DE_LINHASSMALL}&idprod=${idprod}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 0),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const getAllReferencia = async (page = 1, id: string): Promise<TComTotalCountreferencia | Error> => {
  try {
    const urlRelativa = `/referencia?page=${page}&limit=${10}&idproduto=${id}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 10),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAlllistRef = async (filter = '', id = '', tipo = '', idref = ''): Promise<TComTotalCountGetAlllist | Error> => {
  try {
    // Só busca por id quando o usuário ainda não digitou nada — ver mesmo fix em
    // MunicipiosService.getAlllist.
    const urlRelativa: string = (filter === '' && id !== '') ? `/produtoslistref/${id}/${idref}` : `/produtoslist?limit=${Environment.LIMITE_DE_LINHAS}&tipo=${tipo}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data: Array.isArray(data) ? data : [data],
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAlllist = async (filter = '', id = '', tipo = ''): Promise<TComTotalCountGetAlllist | Error> => {
  try {
    // Só busca por id quando o usuário ainda não digitou nada — ver mesmo fix em
    // MunicipiosService.getAlllist.
    const urlRelativa: string = (filter === '' && id !== '') ? `/produtoslist/${id}` : `/produtoslist?limit=${Environment.LIMITE_DE_LINHAS}&tipo=${tipo}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getByIdOnline = async (id: string): Promise<IGetProdutobyid | Error> => {
  try {
    const { data } = await Api.get(`/produtos/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const createreferencia = async (idprod: string, dados: IDetalhesReferencia): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const dadosEnvio = {
      idref: guuid,
      idproduto: idprod,
      ...dados
    };
    const { data } = await Api.post<IDetalhesReferencia>('/referencia', dadosEnvio);
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const createOnline = async (dados: IDetalhesProduto): Promise<string | Error> => {
  try {
    const { precocusto, ...dadosSemReferencia } = dados;
    const guuid = uuidv4();
    const dadosEnvio = {
      idproduto: guuid,
      ...dadosSemReferencia
    };
    const { data } = await Api.post<IDetalhesProduto>('/produtos', dadosEnvio);
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponseCREATE>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateByIdOnline = async (id: string, dados: IDetalhesProdutobyid): Promise<void | Error> => {
  try {
    const { precocusto, ...dadosSemReferencia } = dados;
    await Api.put(`/produtos/${id}`, dadosSemReferencia);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export type TTipoAjusteEstoque = 'entrada' | 'saida';

export interface IitensMovimentoReajuste {
  iditens: string;
  idmov: string;
  idprodutos: string;
  idref: string | null;
  qtds: number;
  qtde: number;
  un: string;
  tipo: number;
  preco: number;
  subtotal: number;
  voutros: number;
  desconto: number;
  total: number;
}
const updateByIdReajusteOnline = async (idprodutos: string, valor: number, tipoAjuste: TTipoAjusteEstoque, un: string): Promise<void | Error> => {
  try {
    const dados: IitensMovimentoReajuste = {
      iditens: uuidv4(),
      idmov: Environment.URL_IDENTRADA,
      idprodutos,
      un,
      idref: null,
      qtde: tipoAjuste === 'entrada' ? valor : 0,
      qtds: tipoAjuste === 'saida' ? valor : 0,
      tipo: tipoAjuste === 'entrada' ? 1 : 2,
      preco: 0,
      subtotal: 0,
      voutros: 0,
      desconto: 0,
      total: 0,
    };
    await Api.post(`/ajusteestoque`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateByIdReferencia = async (id: string, dados: IDetalhesReferencia): Promise<void | Error> => {
  try {
    await Api.put(`/referencia/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateByIdImg = async (id: string, image: File | undefined, urlimge: string | null): Promise<void | Error> => {
  try {
    const dados = { urlimge: urlimge };
    const formData = new FormData();
    Object.keys(dados).forEach((key) => {
      formData.append(key, (dados as any)[key]);
    });
    formData.append('file', image || '');

    await Api.put(`/estoqueupdateimg/${id}`, formData);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const deleteByIdOnline = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/produtos/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const deletereferencia = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/referencia/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const Impressao = async (id: string): Promise<IDetalhesProduto | Error> => {
  try {
    const { data } = await Api.get(`/saidaestoqueimpressao/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export interface IProdutoDuplicado {
  idproduto: string;
  descricao: string;
}

// Verifica se já existe um produto com essa descrição/EAN — usado pelo
// cadastro de produtos ao pressionar Enter nesses campos, pra avisar antes
// de criar um cadastro duplicado (não há constraint de unicidade no banco).
// `idIgnorar` exclui o próprio produto da busca (modo edição).
const buscarDuplicado = async (
  campo: 'descricao' | 'ean',
  valor: string,
  idIgnorar?: string,
): Promise<IProdutoDuplicado | null | Error> => {
  try {
    const { data } = await Api.get('/produtosduplicado', {
      params: { campo, valor, idIgnorar },
    });
    return data || null;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export interface IItemVerificarEstoque {
  idprodutos: string;
  qtde: number;
}

export interface IItemSemEstoque {
  idprodutos: string;
  descricao: string;
  qtdesolicitada: number;
  estoquedisponivel: number;
}

// Usado ao trocar a operação de uma venda de Orçamento pra Venda à Vista/Prazo — confere se os
// itens já lançados têm estoque suficiente. Retorna só os que estão faltando (lista vazia =
// pode prosseguir).
const verificarEstoqueOnline = async (itens: IItemVerificarEstoque[]): Promise<IItemSemEstoque[] | Error> => {
  try {
    const { data } = await Api.post<IItemSemEstoque[]>('/produtos/verificarestoque', { itens });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

// ---------- Offline (ver shared/offline) ----------
// A listagem/busca e o detalhe do produto usam a cópia local sem internet
// (a mesma que o PDV usa) — a tela de detalhe fica só leitura offline (ver
// DetalheDeProduto); cadastrar/alterar/excluir produto só com internet.

const getAll = (page = 1, filter = '', tipo = '', limit = Environment.LIMITE_DE_LINHASSMALL, modobusca = 'contem'): Promise<TComTotalCount | Error> =>
  comOffline(
    () => getAllOnline(page, filter, tipo, limit, modobusca),
    () => buscarProdutos(page, filter, tipo, limit, modobusca),
  );

const getById = (id: string): Promise<IGetProdutobyid | Error> =>
  comOffline(
    () => getByIdOnline(id),
    async () => (await buscarProdutoDetalhe(id)) ?? new Error('Cadastro completo deste produto ainda não está neste computador — sincronize com internet.'),
  );
const create = (dados: IDetalhesProduto) => somenteOnline(() => createOnline(dados));
const updateById = (id: string, dados: IDetalhesProdutobyid) => somenteOnline(() => updateByIdOnline(id, dados));
const updateByIdReajuste = (idprodutos: string, valor: number, tipoAjuste: TTipoAjusteEstoque, un: string) =>
  somenteOnline(() => updateByIdReajusteOnline(idprodutos, valor, tipoAjuste, un));
const deleteById = (id: string) => somenteOnline(() => deleteByIdOnline(id));

// Offline confere pelo estoque da cópia local.
const verificarEstoque = (itens: IItemVerificarEstoque[]): Promise<IItemSemEstoque[] | Error> =>
  comOffline(() => verificarEstoqueOnline(itens), () => verificarEstoqueLocal(itens));

export const ProdutosService = {
  getAll,
  getAllVenda,
  getAllEntrada,
  getAllDashboard,
  getAllPage,
  updateByIdReajuste,
  getAlllist,
  getAlllistRef,
  create,
  getById,
  updateById,
  deleteById,
  updateByIdReferencia,
  updateByIdImg,
  deletereferencia,
  getAllReferencia,
  Impressao,
  createreferencia,
  buscarDuplicado,
  verificarEstoque,
};